import {POLICYDETAIL, POLICYLIST} from 'src/redux/actions/actionTypes';


let policyData = [];

export const mainPolicyReducer = (state = policyData, action) => {
  switch (action.type) {

    case POLICYLIST:
    case POLICYDETAIL:
      /* Login success */
      policyData.splice(0, policyData.length);
      // console.log("test",action.payload.data)
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        policyData.push(action.payload.data.res);
        return policyData;
      }
      return state;

    default:
      return state;
  }
};
  
  